import { useCallback, useContext, useRef, useState } from 'react'
import { AppData, AppDispatch } from './Model'
import { Gallery, Picture, useWidth } from './Look + Feel'
import { LocationWidget, LocationWidgetButton } from './Location'

import addToWallet from './assets/add-to-apple-wallet.png'
import charmInstagram from './assets/charm-instagram.svg'
import charmFacebook from './assets/charm-facebook.svg'
import charmGift from './assets/charm-gift.svg'
import charmDown from './assets/charm-down.svg'
import MaltonsLogo from './assets/maltons-drinks-company-logo-large.js'
import generation from './assets/maltons-two-sides.webp'
import mainMenu from './assets/menu-main-drinks.jpeg'
import porkMenu from './assets/menu-pulled-pork.jpeg'
import icedCoffeeMenu from './assets/menu-iced-coffee.jpeg'
import villageMenu from './assets/menu-village-bite-box.jpeg'
import ourStaff from './assets/our-staff.webp'
import theFleet from './assets/the-fleet.webp'
import maltonsDrinks from './assets/maltons-drinks.jpg'
import mEyes from './assets/m-eyes.webp'

import horseBox from './assets/horse-box.webp'
import indoorBar from './assets/indoor-bar.webp'
import hostess from './assets/hostess.webp'
import sweetCart from './assets/sweet-cart.webp'
import outdoorBar from './assets/outdoor-bar.webp'
import cancelSign from './assets/cancel.svg'

export default function Layout() {
	const endRef = useRef(null)
	return (
		<div className='maltons-drinks'>
			<Header />
			<LocationWidget />
			<Cover />
			<div className='ticker catavalo' style={{ fontSize: 30 }}>There's two sides to everyone...</div>
			<div className='columns menu'>
				<OurMenus />
				<FreeSundae />
			</div>
			<div className='horizon-fade'>
				<div className='columns menu '>
					<RentalServices />
					<PackageMenus />
				</div>
			</div>
			<div className='ticker'>See our latest promotions and our exclusive rental services &amp; deals</div>
			<div className='columns wider'>
				<MaltonsDrinks />
				<OurStaff />
				<TheFleet />
			</div>
			<span ref={endRef} />
			<Footer />
			<Charms end={endRef} />
			<Gallery />
			<Picture />
		</div>
	)
}

function LogoLink() {
	return <a className='logo' href='https://MaltonsUK.co.uk/'><MaltonsLogo /></a>
}

function Header() {
	return (
		<header>
			<LogoLink />
		</header>
	)
}

function Cover() {
	return (
		<img className='cover' src={generation} alt='Generation graphic' />
	)
}

function Footer() {
	const width = useWidth()

	if (width > 600) return (
		<footer className='wider'>
			<div className='first-column'>
				<LogoLink />
				<p><strong>Malton’s Est Ltd, Official Website</strong></p>
				<section>
					<h6>United Kingdom</h6>
					<p>Company number 14690762</p>
				</section>
				<section>
					<LocationWidgetButton />
				</section>
			</div>
			<div className='second-column'>
				<section>
					<h6>Telephone</h6>
					<p><a href='+447340370491'>07340 370 491</a></p>
				</section>
				<section>
					<h6>Address</h6>
					<p>By appointment only: Queen Camel, Yeovil, Somerset</p>
				</section>
				<section>
					<h6>Reach Out</h6>
					<div className='email-addresses'>
						<a href='mailto:info@maltonsuk.co.uk'>info@maltonsuk.co.uk</a>
						<a href='mailto:sales@maltonsuk.co.uk'>sales@maltonsuk.co.uk</a>
						<a href='mailto:beth@maltonsuk.co.uk'>beth@maltonsuk.co.uk</a>
					</div>
				</section>
			</div>
		</footer>
	)

	return (
		<footer>
			<LogoLink />
			<p><strong>Malton’s Est Ltd, Official Website</strong></p>
			<section>
				<h6>Telephone</h6>
				<p><a href='+4407340370491'>07340 370 491</a></p>
			</section>
			<section>
				<h6>Address</h6>
				<p>By appointment only: Queen Camel, Yeovil, Somerset</p>
			</section>
			<section>
				<LocationWidgetButton />
			</section>
			<section>
				<h6>Reach Out</h6>
				<div className='email-addresses'>
					<a href='mailto:info@maltonsuk.co.uk'>info@maltonsuk.co.uk</a>
					<a href='mailto:sales@maltonsuk.co.uk'>sales@maltonsuk.co.uk</a>
					<a href='mailto:beth@maltonsuk.co.uk'>beth@maltonsuk.co.uk</a>
				</div>
			</section>
			<section>
				<h6>United Kingdom</h6>
				<p>Company number 14690762</p>
			</section>
		</footer>
	)
}

function OurMenus() {
	const [ open, setOpen ] = useState(false)

	const items = [ 'coffee', 'icedTea', 'milkshakes', 'specials', 'icedlemonade', 'pulledPork', 'bbqBaps', 'lunchDeal', 'icedCoffee', 'hotChocolates', 'maltonsMobileBar' ]

	return (
		<div className='announcement'>

			<div className='square'>

				<div className='overlay'>
					<h3>Our menus</h3>
					<p>Take a look and give us a visit</p>
					<button onClick={() => setOpen(true)}>See menus</button>
				</div>

				<img src={mEyes} alt='M' />
			</div>


			{open && <div className='popover' onClick={() => setOpen(false)}>

				<div className='card wider' onClick={event => event.stopPropagation()}>

					<button onClick={() => setOpen(false)} className='cancel'><img src={cancelSign} alt='Cancel' /></button>

					<h3>Malton’s Drinks Company</h3>
					<div className='menu-options'>
						{items.map((value, index) => <span key={index}>#{value}</span>)}
					</div>

					<img width={942} height={725} src={mainMenu} alt="Malton’s main menu" />
					<img src={porkMenu} alt="Malton’s pork menu" />
					<img src={icedCoffeeMenu} alt="Malton’s iced coffee menu" />
					<img src={villageMenu} alt="Malton’s village menu" />

					<div className='card-options'>
						<button onClick={() => setOpen(false)}>Close</button>
					</div>
				</div>
			</div>}
		</div>
	)
}

function FreeSundae() {
	return (
		<div className='announcement'>
			<h3>Apple voucher promotion!</h3>
			<p>Download free coupon to your phone</p>
			<p>20% discount off your first order</p>
			<a href='./voucher.pkpass'><img src={addToWallet} alt='Add to Apple Wallet' style={{ width: 150 }} /></a>
		</div>
	)
}

function RentalServices() {
	const [ open, setOpen ] = useState(false)

	return (
		<div className='announcement'>
			<h3>For hire 2025</h3>
			<p>Weddings, Parties, Private Events & Public Events</p>

			<button onClick={() => setOpen(true)}>Rental services</button>
			
			{open && <div className='popover' onClick={() => setOpen(false)}>

				<div className='card' onClick={event => event.stopPropagation()}>

					<button onClick={() => setOpen(false)} className='cancel'><img src={cancelSign} alt='Cancel' /></button>

					<h3>Malton’s Mobile Rental Services – new for 2025!</h3>

					<div className='inset compact responsive-square'><img src={horseBox} alt="And we're gone" /></div>
					<div className='caption'>Horse Box Hire</div>
					<p>Our new horse transport boxes are designed to provide safe and comfortable transportation for your horses. They are made from high-quality materials and are designed to meet the specific needs of animals of all sizes.</p>
					<hr className='compact' />

					<img src={indoorBar} alt="And we're gone" className='inset compact' />
					<div className='caption'>Indoor Bar Hire</div>
					<p>Introducing our new indoor bar hire service! We are excited to offer our clients a unique and convenient way to create a memorable and stylish event. Our indoor bar hire service is perfect for a wide range of events, including weddings, corporate functions, and private parties.</p>
					<hr className='compact' />

					<img src={hostess} alt="And we're gone" className='inset compact' />
					<div className='caption'>Hostess Package Hire</div>
					<p>Our Hostess Package Hire is the perfect solution for any event or occasion. Our experienced and professional hostesses will greet your guests, provide them with information and assistance, and ensure that your event runs smoothly.</p>
					<hr className='compact' />

					<img src={sweetCart} alt="And we're gone" className='inset compact' />
					<div className='caption'>Sweet Cart Hire</div>
					<p>Sweet Cart Hire is a service that provides a beautiful and elegant sweet cart for weddings, parties, and other special events. The cart is filled with a variety of delicious sweets, including chocolates, candies, and pastries, and can be customized to match the theme of the event.</p>
					<hr className='compact' />

					<img src={outdoorBar} alt="And we're gone" className='inset compact' />
					<div className='caption'>Bar Service</div>
					<p>We pride ourselves on our quality and customer service. We use only the finest ingredients and our drinks are prepared with care and attention. We also offer a range of discounts and promotions to our customers.</p>
					<hr className='compact' />

					{/* Pending: New section called "Food Service" */}

					<hr />

					<p><strong>Avaliable now:</strong> Our individual service offerings include horse box, indoor bar, hostess package, sweet cart hire and coffee/shakes or alcohol bar services. For a stress-free event please see our rental package menus, also new for 2025.</p>

					<button className='brand' onClick={() => alert('Unavailable until April 2025')}>Book rental services</button>

					<hr />

					<div className='card-options'>
						<button onClick={() => setOpen(false)}>Close</button>
					</div>

					<p><strong>Note: This section is currently under development, more detail and info coming soon</strong></p>
				</div>
			</div>}
		</div>
	)
}

function PackageMenus() {
	const [ open, setOpen ] = useState(false)

	return (
		<div className='announcement'>
			<h3>Exclusive for rentals</h3>
			<p>See our menus only for hire function packages</p>

			<button onClick={() => setOpen(true)}>Rental package menus</button>
			
			{open && <div className='popover' onClick={() => setOpen(false)}>
				<div className='card' onClick={event => event.stopPropagation()}>
					<button onClick={() => setOpen(false)} className='cancel'><img src={cancelSign} alt='Cancel' /></button>
					
					<h3>Rental package menus</h3>
					<p>When you're hosting an event and you want to stay in budget but also want to ensure nothing is lacking on the day.</p>

					<div className='inset responsive-square'><img src='./uploads/Package/castlepoint.jpg' alt="Butterflies adorn Castlepoint mall's atrium" /></div>
					<div className='caption'>Package deal: The Hostess</div>

					<p><strong>The Hostess</strong> is our standard entry-level package and keeps getting improved by listening to feedback from our clients.</p>

					<h4>Included in the price</h4>
					<div className='menu-options'>
						<span>Item #1</span>
						<span>Item #2</span>
						<span>Item #3</span>
						<span>Item #4</span>
						<span>Item #5</span>
						<span>Item #6</span>
						<span>Item #7</span>
						<span>Item #8</span>
						<span>Item #9</span>
						<span>Item #10</span>
					</div>
					
					<button className='brand' onClick={() => alert('Unavailable until April 2025')}>Book &ldquo;The Hostess&rdquo;</button>

					<hr />

					<div className='inset responsive-square'><img src='./uploads/Package/castlepoint-stand.jpg' alt="And we're gone" /></div>
					<div className='caption'>Package deal: The Ambassador</div>

					<p>For longer events such as festivals and movie casting we offer <strong>The Ambassador</strong> as our top-tier service and shouldn't dissapoint whether it's for one morning or indefinitely.</p>

					<h4>Included in the price</h4>
					<div className='menu-options'>
						<span>Item #1</span>
						<span>Item #2</span>
						<span>Item #3</span>
						<span>Item #4</span>
						<span>Item #5</span>
						<span>Item #6</span>
						<span>Item #7</span>
						<span>Item #8</span>
						<span>Item #9</span>
						<span>Item #10</span>
					</div>

					<button className='brand' onClick={() => alert('Unavailable until April 2025')}>Book &ldquo;The Ambassador&rdquo;</button>

					<hr />

					<div className='card-options'>
						<button onClick={() => setOpen(false)}>Close</button>
					</div>

					<p><strong>Note: This section is currently under development, more detail and info coming soon</strong></p>
				</div>
			</div>}
		</div>
	)
}

function OurStaff() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={ourStaff} alt='Our staff in trailer cab and front of house' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'staff' })}>The Staff</button>
			</div>
		</div>
	)
}

function MaltonsDrinks() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={maltonsDrinks} alt='' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'drinks' })}>Malton’s Drinks</button>
			</div>
		</div>	
	)
}

function TheFleet() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={theFleet} alt='White display carriage stationed in patio' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'vehicles' })}>Browse Fleet</button>
			</div>
		</div>
	)
}

function Charms({ end }) {
	const { heading } = useContext(AppData)
	const dispatch = useContext(AppDispatch)
	const autoscroll = useCallback(event => {
		event.preventDefault()
		if (heading === 'down') {
			end.current.scrollIntoView({ behavior: 'smooth' })
			dispatch({ type: 'heading', value: 'up' })
		}
		else {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
			dispatch({ type: 'heading', value: 'down' })
		}
	}, [ end, heading, dispatch ])
	return (
		<div className='charms'>
			<a href='https://www.instagram.com/maltons_drinks_company/'><img src={charmInstagram} alt='Instagram charm' /></a>
			<a href='https://www.facebook.com/people/Maltons-Drinks-Company/100089150328931/'><img src={charmFacebook} alt='Facebook charm' /></a>
			<a href='./voucher.pkpass'><img src={charmGift} alt='Gift charm' /></a>
			<a href='#contact' onClick={autoscroll}><img src={charmDown} alt='Scroll to end' className={`scroll-${heading}`} /></a>
		</div>
	)
}
